import React from "react";
import { Button, Result } from "antd";
import { PageContainer } from "@ant-design/pro-components";

const NotFound: React.FC = () => (
  <PageContainer
    style={{ alignContent: "center", paddingTop: 50 }}
    content={
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary" onClick={() => window.history.back()}>
            Back Home
          </Button>
        }
      />
    }
  />
);

export default NotFound;
